module.exports = __webpack_public_path__ + "img/icon_1.0ab91195.png";